import { render, staticRenderFns } from "./InstantRefundBadge.vue?vue&type=template&id=4b7f3b57&scoped=true&lang=pug&"
import script from "./InstantRefundBadge.vue?vue&type=script&lang=js&"
export * from "./InstantRefundBadge.vue?vue&type=script&lang=js&"
import style0 from "./InstantRefundBadge.vue?vue&type=style&index=0&id=4b7f3b57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f3b57",
  null
  
)

export default component.exports